import React, { useContext, useState } from "react";

import Header from "../components/Header";
import CardFotoInforme from "../components/informes/CardFotoInforme";
import { PDFDownloadLink } from "@react-pdf/renderer";
import TestPDF from "../components/informes/PDFS/TestPDF";
import TestPDFhtml2 from "../components/informes/PDFS/TestPDFhtml2";
import { Image } from "react-bootstrap";



import Context from "../Context";

const Informes = () => {
  const { showIcons, setShowIcons, showLogo, setShowLogo } =
    useContext(Context);

  

 

  return (
    <>
      <section id="fotos">
        {showLogo && (
          <Image
            className="logoPDF"
            src="./assets/images/cmf-logo.png"
            alt="logo cmf"
          />
        )}
        {/* <Header title="Fotos Clave en la Evaluación " /> */}

        <div className="wraper-cards">
          <CardFotoInforme title="Posterior"  htmlFor="fileUpload2"/>
          <CardFotoInforme title="Test de Flexión" htmlFor="fileUpload3"/>
          <CardFotoInforme title="Test Antebáscula" htmlFor="fileUpload4"/>
        </div>
      </section>

      <section>
        {showLogo && (
          <Image
            className="logoPDF"
            src="./assets/images/cmf-logo.png"
            alt="logo cmf"
          />
        )}

        {/* <Header title="Fotos Evaluación" /> */}

        <div className="wraper-cards">
          <CardFotoInforme title="Test Retrobáscula" htmlFor="fileUpload5"/>
          <CardFotoInforme title="Decubito Supino(EIAS)" htmlFor="fileUpload6"/>
          <CardFotoInforme title="Decubito Supino(Largo Pierna)" htmlFor="fileUpload7"/>
        </div>
      </section>

       <section>
        {showLogo && (
          <Image
            className="logoPDF"
            src="./assets/images/cmf-logo.png"
            alt="logo cmf"
          />
        )}

        {/* <Header title="Fotos Evaluación" /> */}

        <div className="wraper-cards">
          <CardFotoInforme title="Decubito Prono(Isquiones)" htmlFor="fileUpload8"/>
        </div>
      </section>

     
    </>
  );
};

export default Informes;
